import { Container } from 'inversify'

export default new Container({ autobind: true })
